<template>
  <div>
    <div
      class="dt-detail-info__content-sec dt-detail-info__content-sec--customer"
    >
      <div class="row address">
        <div class="col-md-3">
          <span class="val">{{ item.name }}</span>
          <!-- <span class="val">{{ item.telephone_no }}</span> -->
        </div>
      </div>
      <div class="row address">
        <div class="col-md-6">
          <span class="val">{{ item.phone }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    item: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
